module.exports = __webpack_public_path__ + "static/media/cross_white.430e13c9.svg";